export default __webpack_public_path__ + "static/media/CarBlue.f0899ce4.png";